import { ISetPaginationPayload } from '../actions/pagination';
import {IApiQueryData, IProductReviewActionState} from '../interfaces';
import { PARAM_PAGE } from '../constants';

export const doSetPagination = (state: IProductReviewActionState, payload: ISetPaginationPayload): IProductReviewActionState => {
    const newApiQueryData: IApiQueryData = {
        ...state.apiQueryData,
        [PARAM_PAGE]: payload[PARAM_PAGE],
    };

    return {
        ...state,
        apiQueryData: newApiQueryData,
    };
};
